export default __webpack_public_path__ + "img/rank-desc-1b6ab41b.png";